import React, { useState } from 'react';
import ItemsDroppable from './Droppable';
import styled from 'styled-components';
import { IService, IStaffItem } from 'features/cashier/services/types/api';
import { IStaffItemData } from 'services/shop/types/staff';
import { Avatar, Col, Row } from 'antd';
import Text from 'components/Text';
import Icon from 'assets/Icons';
import arrowDown from '../ItemsDnD/Icon/down.svg';
import clsx from 'clsx';
import { DiscountType, encodeDraftServiceSwitchStaffId, getComboCalcData, getComboIdFromSerUUID, IComboCalcData, ITEM_HANDLE_MODE } from 'features/cashier/services/constants';
import ItemsDraggable from './Draggable';
import { IDraftQuickPayItem } from 'features/cashier/services/types/quickpay';
import { IShopAllSetting } from 'services/shop/types/setting';
import { useAppDispatch } from 'store/hooks';
import cashierActions from 'features/cashier/services/actions';
import { formatCurrency } from 'utils/formatCurrency';
import packageTicketIcon from 'assets/package-assets/arrange-d2464f.svg';
import shopSelectors from 'services/shop/selectors';
import { getPackageTierSessions } from 'features/cashier/services/package-ticket-item';
import { SERVICE_ITEM_TYPE } from 'features/cashier/services/types/constant';
import Button from 'components/Button';
import IcFinishTurn from './Icon/ic_finish_turn.svg';
import IcUndoTurn from './Icon/ic_undo_turn.svg';
import Box from 'components/Box';
import { getServiceColorSet } from 'features/settingService/pages/SettingPage/components/ServicesSettingV2/ServicePart/PopoverChangeColors';
import { SERVICE_COLOR_SETS } from 'services/shop/constants';
import { get } from 'lodash';
import { IDraftDiscountItemValue } from 'features/cashier/services/types/discount';

export type IPropertyDraftQuickPay = {
  staffId: string, itemId: string, value: number, itemName: string;
}
type Props = {
  v2?: boolean;
  active?: boolean;
  activeDrag?: boolean;
  data: IStaffItem;
  staff: IStaffItemData | undefined;
  onActiveStaff: (data: string) => void;
  setDraffStaffId: (staffId: string) => void;
  onRemoveStaff: (staffId: string) => void;
  draftServiceSwitchStaff: string | null;
  highlightItemId: string | null | undefined;
  enableSwitchStaff: boolean;
  setDraftServiceSwitchStaff: (staffId: string, itemId: string) => void;
  handleUpdateQuickPay: (type: IDraftQuickPayItem['typeDraft'], draft: IPropertyDraftQuickPay) => (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  itemMode: ITEM_HANDLE_MODE | null;
  allSetting: IShopAllSetting | null;
  onHandleDiscount: (e: React.MouseEvent, staff: IStaffItem, service: IService) => void;
  onHandleDiscountCombo: (e: React.MouseEvent, payload: IDraftDiscountItemValue | null) => void
  onSwitchStaff: (staffId: string) => void;
  onUpdateStaffTurnStatus?: (staffId: string, finishTurn: boolean) => void;
  isTurnHandlerVisible?: boolean;
};
const ItemStaffTicket = ({
  onSwitchStaff,
  activeDrag,
  onHandleDiscount,
  onHandleDiscountCombo,
  allSetting,
  data, active,
  staff,
  onActiveStaff,
  setDraffStaffId,
  onRemoveStaff,
  draftServiceSwitchStaff,
  highlightItemId,
  enableSwitchStaff,
  setDraftServiceSwitchStaff,
  handleUpdateQuickPay,
  itemMode,
  onUpdateStaffTurnStatus,
  isTurnHandlerVisible,
}: Props) => {
  const dispatch = useAppDispatch();
  const packagePrograms = shopSelectors.data.packagePrograms();
  const [activeTab, setActiveTab] = useState(true);
  const visibleSwitchStaff = !!(
    activeDrag &&
    draftServiceSwitchStaff &&
    !draftServiceSwitchStaff.includes(data.staffId)
  );
  return (
    <ItemsDroppable
      id={data.staffId} key={data.staffId}
      className='ItemStaffTicket'
    >
      <BillPanelItemHeader className={active ? 'active-staff' : ''} onClick={(e: any) => [e.stopPropagation(), onActiveStaff(data.staffId)]}>
        <Row align={'middle'} >
          <Avatar size={44} src={staff?.urlImage} alt='avatar' >{data.staffName?.[0] || 'A'}</Avatar>
          <Text ml={0.5} variant="H9" color="text_3" style={{ fontSize: 30, color: '#6FABB6' }}>
            {data.staffName || ''}
          </Text>
          <ButtonSwitchStaffItem onClick={() => setDraffStaffId(data.staffId)} />
        </Row>
        <div style={{ flex: 1 }} />
        {isTurnHandlerVisible && <>{
          !data.finishTurn ? <ButtonTurnHandle type='finish' onClick={() => onUpdateStaffTurnStatus?.(data.staffId, true)} /> : <ButtonTurnHandle type='undo' onClick={() => onUpdateStaffTurnStatus?.(data.staffId, false)} />
        }</>}
        {visibleSwitchStaff && <ButtonSwitchStaff onClick={() => onSwitchStaff(data.staffId)} />}
        <ButtonRemoveStaff onClick={() => onRemoveStaff(data.staffId)} />
        <ButtonArrowDown active={activeTab} onClick={() => setActiveTab(!activeTab)} />
      </BillPanelItemHeader>
      <div
        style={!activeTab ? { display: 'none' } : { display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0 0.5rem', paddingBottom: '16px' }}
      >
        {data.services.length > 0 ? (
          data.services.map((serviceItem) => {
            const draftSwitchStaffActive = serviceItem?.uuid_local
              ? draftServiceSwitchStaff?.includes(serviceItem?.uuid_local)
              : false;

            const discount = serviceItem.discountType === DiscountType.PERCENT ? ((serviceItem.price ?? 0) * serviceItem.discount / 100) : serviceItem.discount ?? 0;
            const afterDiscountPrice = serviceItem.price - discount;
            const isHighLight = (serviceItem?.uuid_local === highlightItemId) && !draftSwitchStaffActive;
            const isPackageItem = serviceItem.itemType === SERVICE_ITEM_TYPE.PACKAGE;
            const isUsePackageItem = serviceItem.itemType === SERVICE_ITEM_TYPE.USE_PACKAGE;
            // gói bán và buổi dùng gói đều gắn với gói của khách: cùng icon, tên đậm, không cho quick pay sửa
            const isPackageLikeItem = isPackageItem || isUsePackageItem;
            // số buổi tra từ package program đã load theo itemId (= tier.id); không tra được thì ẩn dòng
            const packageSessions = isPackageItem ? getPackageTierSessions(packagePrograms, serviceItem.itemId) : null;

            const draftPropertyDraftQuickPay: IPropertyDraftQuickPay = {
              staffId: data.staffId,
              itemId: serviceItem?.uuid_local ?? '',
              itemName: serviceItem.itemName,
              value: serviceItem.price,
            };

            const keyDnd = serviceItem.uuid_local + '/' + data.staffId;
            const serviceColor = get(SERVICE_COLOR_SETS, [serviceItem.itemId], '');
            const colorSet = getServiceColorSet(serviceColor);

            const comboId = getComboIdFromSerUUID(serviceItem?.uuid_local || '');

            const comboData = getComboCalcData(comboId);
            const isIndex0 = comboData?.services?.findIndex(s => s.uuid_local === serviceItem.uuid_local) === 0;
            const isComboActive = (isIndex0 && comboId)
              ? draftServiceSwitchStaff === encodeDraftServiceSwitchStaffId({ staffId: data.staffId, itemId: comboId })
              : false;
            return (
              <>
                {
                  isIndex0 && <ItemCollapseStyled
                    key={comboId} data={{ uuid: serviceItem.uuid_local, staffId: data.staffId }} id={''}
                    className='ItemCollapseStyled'
                    parentCombo
                  >
                    <button onClick={() => {
                      setDraftServiceSwitchStaff?.(
                        data.staffId,
                        comboId ?? ''
                      );
                    }} style={{ width: '100%', display: 'flex', alignSelf: 'stretch', alignItems: 'center' }}>
                      <Col>
                        <Box display='flex' alignItems='center' justifyContent='center' gap='2' style={{ zoom: 1.2 }}>
                          <ButtonEditQuickPay>
                            <Text variant="CONTENT_1" color={'text_3'}>{comboData?.data?.serviceName || ''}</Text>
                          </ButtonEditQuickPay>
                          <TextPackage>package</TextPackage>
                        </Box>
                      </Col>
                      <Col flex={'auto'} />
                      <Col>
                        <PriceBoxContainerStyled>
                          <PriceBoxStyled>
                            <CenterBox>
                              {!!comboData.discount && <Text
                                textDecorate="line-through"
                                variant="H9"
                                color={'primary_active'}
                                mr={0.5}
                              >
                                {formatCurrency(comboData.price)}
                              </Text>}
                              <ButtonEditQuickPay>
                                <TextPackage style={{ fontSize: '2rem' }}>
                                  {formatCurrency(comboData.finalPrice)}
                                </TextPackage>
                              </ButtonEditQuickPay>
                            </CenterBox>
                            <ActionItemCombo comboId={comboId} active={isComboActive} staff={data} comboData={comboData} onHandleDiscountCombo={onHandleDiscountCombo} />
                          </PriceBoxStyled>
                        </PriceBoxContainerStyled>
                      </Col>

                    </button>
                  </ItemCollapseStyled>
                }
                <ItemCollapseStyled
                  active={draftSwitchStaffActive}
                  background={colorSet.bg}
                  //  border: '1px solid ' + colorSet.stroke
                  enableSwitchStaff={enableSwitchStaff}
                  highlightItemId={isHighLight}
                  key={keyDnd} data={{ uuid: serviceItem.uuid_local, staffId: data.staffId }} id={keyDnd}
                  enableDrag={activeDrag}
                  className='ItemCollapseStyled'
                  isCombo={!!comboData}
                  isAddOn={serviceItem.isAddOn}
                >
                  <button style={{ width: '100%', display: 'flex', alignSelf: 'stretch', alignItems: 'center' }} onClick={() =>
                    setDraftServiceSwitchStaff(
                      data.staffId,
                      serviceItem?.uuid_local ?? ''
                    )
                  }>
                    <Col>
                      <Row style={{ gap: '8px', alignItems: 'center' }}>
                        {/* icon package là <img> svg nên dùng filter để chuyển trắng trên nền highlight đen */}
                        {isPackageLikeItem && <img src={packageTicketIcon} alt='' style={{ width: 24, height: 24, flexShrink: 0, filter: isHighLight ? 'brightness(0) invert(1)' : undefined }} />}
                        <ButtonEditQuickPay onClick={isPackageLikeItem ? undefined : handleUpdateQuickPay('NAME', draftPropertyDraftQuickPay)} style={{ marginRight: '2.5rem' }}>
                          <Text variant="CONTENT_1" style={(serviceItem.isAddOn || isPackageLikeItem) ? { fontWeight: '600' } : {}} color={isHighLight ? 'fill_1' : (serviceItem.isAddOn ? 'v2_green_6' : 'text_3')}>{serviceItem.isAddOn ? '+ ' : ''}{serviceItem.itemType === 'VIP' ? (serviceItem.itemName || 'VIP') : serviceItem.itemName}</Text>
                        </ButtonEditQuickPay>
                        {allSetting?.showSupplyFeeCashier || itemMode === ITEM_HANDLE_MODE.SUPPLY_FEE ? (
                          <button type='button' onClick={() => {
                            dispatch(
                              cashierActions.setDraftSupplyFeeItemModal({
                                staffId: data.staffId,
                                service_uuid_local: serviceItem.uuid_local || '',
                                supplyFee: serviceItem.supplyFee || 0,
                                itemName: serviceItem.itemName,
                              })
                            );
                          }}>
                            <Text variant="CONTENT_1" color={'info_3'} style={{ fontStyle: 'italic', fontWeight: '600' }}>(Supply Fees: {formatCurrency(serviceItem.supplyFee)})</Text>
                          </button>
                        ) : null}
                      </Row>
                      {/* dòng phụ của item package: căn trái thẳng hàng tên (button mặc định căn giữa), lùi bằng icon 24px + gap 8px */}
                      {packageSessions !== null && (
                        <Text
                          variant="BODY_1"
                          color={isHighLight ? 'fill_1' : 'text_2'}
                          textAlign='left'
                          mt={0.25}
                          style={{ paddingLeft: '32px' }}
                        >
                          {packageSessions} Sessions
                        </Text>
                      )}
                    </Col>
                    <Col flex={'auto'} />
                    <Col>
                      <PriceBoxContainerStyled>
                        <PriceBoxStyled>
                          <CenterBox>

                            {!!serviceItem?.discount && <Text
                              textDecorate="line-through"
                              variant="H9"
                              color={isHighLight ? 'fill_1' : 'primary_active'}
                              mr={0.5}
                            >
                              {formatCurrency(serviceItem.price)}
                            </Text>}
                            <ButtonEditQuickPay onClick={isPackageLikeItem ? undefined : handleUpdateQuickPay('PRICE', draftPropertyDraftQuickPay)}>
                              <Text variant="H9" style={serviceItem.isAddOn ? { fontWeight: '600' } : {}} color={isHighLight ? 'fill_1' : (serviceItem.isAddOn ? 'v2_green_6' : 'text_3')} mr={0.5}>
                                {formatCurrency(afterDiscountPrice)}
                              </Text>
                            </ButtonEditQuickPay>
                          </CenterBox>
                          <ActionItem displaySupplyFee={!!allSetting?.displaySupplyFeeCashier} onHandleDiscount={(event: React.MouseEvent) => onHandleDiscount(event, data, serviceItem)} active={draftSwitchStaffActive} staff={data} service={serviceItem} itemMode={itemMode} isHighLight={isHighLight} />
                        </PriceBoxStyled>
                      </PriceBoxContainerStyled>
                    </Col>

                  </button>
                </ItemCollapseStyled>
              </>
            );
          })
        ) : (
          <ItemCollapseNoneStyled>
            <Text variant="H8" color="text_2">
              Select services
            </Text>
          </ItemCollapseNoneStyled>
        )}
      </div >
    </ItemsDroppable>
  );
};

export default ItemStaffTicket;
const ButtonTurnHandle = ({ onClick, type }: { onClick?: () => void, type: 'finish' | 'undo' }) => {
  return (
    <ButtonTurnHandleStyled cardCashier ntype={type === 'finish' ? 'LIGHT_BLUE' : 'SECONDARY'} height={2.5} onClick={onClick}>
      <Box display='flex' alignItems='center' gap='2'>
        <img src={type === 'finish' ? IcFinishTurn : IcUndoTurn} alt={type} />
        <span>{type === 'finish' ? 'Finish Turn' : 'Undo Turn'}</span>
      </Box>
    </ButtonTurnHandleStyled>
  );
};
const ButtonTurnHandleStyled = styled(Button)`
span {
  color: #505050;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

&.LIGHT_BLUE {
  span {
    color: #2D6772;
  }
}
`;

const BillPanelItemHeader = styled.button`
  padding: 6px 16px;
  padding-right: 8px;
  border-bottom: 1px solid #86909c;
  background: #fff;
  margin-bottom: 4px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  &:hover {
    background: #ffe5e782;
  };
  display: flex;
  align-items: center;
  &.active-staff {
    background: #FFE5E7;
    border-bottom: 1.5px solid rgb(245, 118, 127);
  }
`;

const ButtonSwitchStaffItem = ({ onClick }: { onClick: () => void }) => {
  return (
    <ButtonSwitchStaffStyled className='changeStaff' onClick={(e: any) => {
      e.stopPropagation();
      onClick();
    }}><Icon type="changeCustomer" fill='#6FABB6' /></ButtonSwitchStaffStyled>
  );
};
const ButtonSwitchStaffStyled = styled.button`
  align-self: stretch;
  width: 45px;
  padding:0 0.5rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: rgba(255,255,255);
  }
  &.changeStaff {
    padding: 0;
  }
`;

const ButtonRemoveStaff = ({ onClick }: { onClick: () => void }) => {
  return (
    <ButtonSwitchStaffStyled
      onClick={(e: any) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Row align={'middle'} justify={'center'}>
        <Icon type='deleteIconCashier' />
      </Row>
    </ButtonSwitchStaffStyled>
  );
};


const ButtonArrowDown = ({ onClick, active }: { onClick: () => void, active?: boolean }) => {
  return <ButtonArrowDownStyled className={clsx(active && 'active')} onClick={(e: any) => [e.stopPropagation(), onClick()]}>
    <img src={arrowDown} alt="arrowDown" />
  </ButtonArrowDownStyled>;
};
const ButtonArrowDownStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  align-self: stretch;
  border-radius: 5px;
  &:hover {
    cursor: pointer !important;
    background: #fff;
  }
  img {
  
    width: 28px;
    height: 28px;
    transition-property: all;
    transition-delay: .1s;
    transition-duration: .1s;
    transition-timing-function: ease-in;
    transform: rotate(-90deg);
  }
  &.active img {
    transform: rotate(0deg);
  }
`;
const ItemCollapseStyled = styled(ItemsDraggable).withConfig({
  shouldForwardProp: (prop) => !['enableSwitchStaff', 'isAddOn'].includes(prop),
}) <{ active?: boolean; enableSwitchStaff?: boolean, highlightItemId?: boolean, background?: string, isCombo?: boolean, parentCombo?: boolean, isAddOn?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.25rem 0.5rem;
  align-self: stretch;
  border-radius: 5px;
  background: transparent;
  &:hover {
    background: #e5e6eb;
  }
  ${({ active }) =>
    active
      ? `
    background: var(--blue-headline, #C6E9EF);
    &:hover {
      background: var(--blue-headline, #C6E9EF);
    }
  `
      : ''}
   
  ${({ background }) =>
    background
      ? `
    background: ${background};
    &:hover {
      background: ${background};
    }
`
      : ''}
    

  ${({ highlightItemId }) =>
    highlightItemId
      ? `
    background: black;
    &:hover {
      background: black;
    }
`
      : ''}

  ${({ isCombo }) =>
    isCombo
      ? `
    padding-left: 3rem;
`
      : ''}
  ${({ isAddOn }) =>
    isAddOn
      ? `
    padding-left: 1.5rem;
`
      : ''}
  ${({ parentCombo }) =>
    parentCombo
      ? `
     &:hover {
        background: unset;
      }
`
      : ''}

  &.transform {
    .CONTENT_1, .H9 {
      color: #fff !important; 
    }
  }
`;

const ButtonEditQuickPay = styled.button``;
const PriceBoxContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

const PriceBoxStyled = styled.div`
  display: flex;
  align-items: center;
  button {
    display: flex;
  }
`;

const CenterBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type ActionItemProps = {
  onHandleDiscount: (event: React.MouseEvent) => void,
  staff: IStaffItem,
  service: IService,
  itemMode: ITEM_HANDLE_MODE | null,
  isHighLight?: boolean,
  active?: boolean;
  displaySupplyFee?: boolean;
};
const ActionItem = ({ staff, onHandleDiscount, service, itemMode, isHighLight, active = false, displaySupplyFee = false }: ActionItemProps) => {
  const dispatch = useAppDispatch();

  const handleClickCloseService = () => {
    dispatch(
      cashierActions.removeServiceOfItem({
        staffId: staff.staffId,
        serviceId: service.uuid_local,
      })
    );
  };

  const handleClickSupplyFeeItem = () => {
    dispatch(
      cashierActions.setDraftSupplyFeeItemModal({
        staffId: staff.staffId,
        service_uuid_local: service.uuid_local || '',
        supplyFee: service.supplyFee || 0,
        itemName: service.itemName,
      })
    );
  };

  // discount của dòng dùng gói là phần owner gánh để khách trả $0; sửa tay sẽ biến buổi đã trả thành tiền phải trả
  const isUsePackageItem = service.itemType === SERVICE_ITEM_TYPE.USE_PACKAGE;

  const handleClickDiscountItem = (event: React.MouseEvent) => {
    if (onHandleDiscount) return onHandleDiscount(event);
    dispatch(
      cashierActions.setDraftDiscountItemModal({
        staffId: staff.staffId,
        service_uuid_local: service.uuid_local || '',
        amount: service.price,
        discount: service.discount,
      })
    );
  };

  if (active) {
    return <>
      {!isUsePackageItem && (
        <ActionItemStyled
          onClick={(e: any) => [
            e.stopPropagation(),
            handleClickDiscountItem(e),
          ]}
        >
          <Icon type="discount" fill={isHighLight ? '#fff' : '#000'} />
        </ActionItemStyled>
      )}
      {displaySupplyFee && (
        <ActionItemStyled
          onClick={(e: any) => [
            e.stopPropagation(),
            handleClickSupplyFeeItem(),
          ]}
        >
          <Icon type="moneyExchange" fill='#6FABB6' />
        </ActionItemStyled>
      )}
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickCloseService(),
        ]}
      >
        <Icon type="circleClose" />
      </ActionItemStyled>
    </>;
  }

  if (itemMode === ITEM_HANDLE_MODE.SUPPLY_FEE) {
    return (
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickSupplyFeeItem(),
        ]}
      >
        <Icon type="moneyExchange" fill='#6FABB6' />
      </ActionItemStyled>
    );
  }

  if (itemMode === ITEM_HANDLE_MODE.DELETE_ITEM) {
    return (
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickCloseService(),
        ]}
      >
        <Icon type="circleClose" />
      </ActionItemStyled>
    );
  }

  if (itemMode === ITEM_HANDLE_MODE.DISCOUNT_ITEM && !isUsePackageItem) {
    return (
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickDiscountItem(e),
        ]}
      >
        <Icon type="discount" fill={isHighLight ? '#fff' : '#000'} />
      </ActionItemStyled>
    );
  }

  return <></>;
};

const ActionItemCombo = ({ staff, active, comboData, comboId, onHandleDiscountCombo }: { comboId?: string, staff: IStaffItem, active?: boolean; comboData: IComboCalcData; onHandleDiscountCombo: (e: React.MouseEvent, payload: IDraftDiscountItemValue | null) => void }) => {
  const dispatch = useAppDispatch();

  const handleClickCloseService = () => {
    dispatch(
      cashierActions.removeComboItem({
        staffId: staff.staffId,
        comboId: comboId ?? '',
      })
    );
  };

  const handleClickDiscountItem = (e: React.MouseEvent) => {
    onHandleDiscountCombo(e, {
      staffId: staff.staffId,
      comboId: comboId ?? '',
      amount: comboData.price,
      discount: comboData.discount,
      service_uuid_local: comboId ?? '',
    });
  };

  if (active) {
    return <>
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickDiscountItem(e),
        ]}
      >
        <Icon type="discount" fill={'#000'} />
      </ActionItemStyled>
      <ActionItemStyled
        onClick={(e: any) => [
          e.stopPropagation(),
          handleClickCloseService(),
        ]}
      >
        <Icon type="circleClose" />
      </ActionItemStyled>
    </>;
  }
  return <></>;
};

const ActionItemStyled = styled.button`
  height: 2rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 100%;
    height: 100%;
  }
`;

const ItemCollapseNoneStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ButtonSwitchStaff = ({ onClick }: { onClick: () => void }) => {
  return (
    <ButtonSwitchStaffStyled
      style={{ width: 'auto' }}
      onClick={(e: any) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Row align={'middle'} justify={'center'}>
        <Icon type="switch" />
        <Text ml={0.25} variant="H9" color="info_3">
          Switch
        </Text>
      </Row>
    </ButtonSwitchStaffStyled>
  );
};

const TextPackage = styled.span`
  color: #1D2129;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: bolder;
  line-height: normal;
`;